function Bot() {
	this.build();
	barbaCallbacks.push(this);
}

Bot.prototype.build = function(){
	let that = this;
	this.lot = false;
	this.program = false;

	$('.ctabot-link-help, .ctabot-link-icon').on('click', function () {
		that.init(0);
		that.lot = false;
		that.program = false;
	});

	$('.js-bot-plan').on('click', function (e) {
		e.preventDefault();
		that.lot = $(this).data('lot');
		that.program = $(this).data('program');
		let step = $('.bot-btn:eq(1)').data('step');
		that.init(step, that.program, that.lot);
	});
};

Bot.prototype.init = function (step, program, lot) {

	let that = this;

	$('body').addClass('bot-open');
	$(document).click(function (e) {
		if ($(e.target).closest('.bot-step').length === 0 && $(e.target).closest('.ctabot-link').length === 0 && !$(e.target).closest('a').hasClass('js-bot-plan') && $('body').hasClass('bot-open')) {
			that.close();
		}
	});

	$('.bot-close').on('click', function () {
		that.close();
	});

	$('.bot-btn').on('click', function () {
		that.step($(this).data('step'));
	});

	$('.bot-back').on('click', function () {
		that.step(0);
		that.lot = false;
		that.program = false;
	});

	$('#chatbot_program').on('change', function () {
		if ($(this).val() != "") {
			that.close();
            window.location = $(this).val();
		}
	});

	that.step(step, program, lot);
};

Bot.prototype.close = function () {
	$('.bot-step').removeClass('active');
	$('body').removeClass('bot-open');
};

Bot.prototype.step = function (step, program, lot) {

	$('.bot-step').removeClass('active');
	let bot_active = $('#bot-step-' + step).addClass('active');
	if (program) {
		bot_active.find('.field-program option[value="' + program + '"]').prop('selected', true);
	}
	if (lot) {
		bot_active.find('.field-lot option[value="' + lot + '"]').prop('selected', true);
	}

	bot_active.find('.field-program select').on('change', function () {
		const options = bot_active.find('.field-lot select option');
		const currentProg = $(this).val();
		options.hide();
		options.each(function (index, elem) {
			if (elem.value.indexOf(currentProg) === 0) {
				$(elem).show();
			}
		});
	});

	if (step > 0) {
		$('.bot-back').addClass('visible');
	} else {
		$('.bot-back').removeClass('visible');
	}
};
